import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Typography,
  CircularProgress,
  Button,
  Switch,
  Card,
  CardContent,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { API, graphqlOperation, Auth } from "aws-amplify";
import CustomOverlay from "../../components/CustomOverlay";
import { getSeller } from "../../graphql/queries"; // 相対パスは必要に応じて調整

const Profile = () => {
  const [overlay, setOverlay] = useState(true);
  const [currentUserInfo, setCurrentUserInfo] = useState({});
  const [sellerForm, setSellerForm] = useState({
    name: "",
    address: "",
    phone: null,
    postalFirst: "",
    postalSecond: "",
  });
  const [connectedStripe, setConnectedStripe] = useState(false);
  const [registeredSeller, setRegisteredSeller] = useState(false);

  useEffect(() => {
    const fetchSellerInfo = async () => {
      try {
        setOverlay(true);
        
        // Auth.currentAuthenticatedUser()を使用してユーザー情報を取得
        const user = await Auth.currentAuthenticatedUser();
        const userAttributes = user.attributes;
        
        setCurrentUserInfo({
          email: userAttributes.email,
          username: user.username
        });

        const response = await API.graphql({
          query: getSeller,
          variables: { id: userAttributes.sub },
          authMode: 'AMAZON_COGNITO_USER_POOLS'
        });
        
        const seller = response.data.getSeller;

        if (seller?.stripeID) {
          setConnectedStripe(true);
        }

        if (seller?.name && seller?.address && seller?.phone && seller?.postal) {
          setRegisteredSeller(true);
          const postalFirst = seller.postal.substr(0, 3);
          const postalSecond = seller.postal.substr(-4);
          setSellerForm({ ...seller, postalFirst, postalSecond });
        }

      } catch (error) {
        console.error('ユーザー情報取得エラー:', error);
      } finally {
        setOverlay(false);
      }
    };

    fetchSellerInfo();
  }, []); // 依存配列から currentUserInfo と sellerForm を削除

  return (
      <Box mx="auto" maxWidth={600}>
        {/* オーバーレイ */}
        <CustomOverlay overlay={overlay} />

        {/* タイトル */}
        <Grid container justifyContent="flex-start" style={{ marginBottom: "16px" }}>
          <Typography variant="h5">プロフィール</Typography>
        </Grid>

        {/* 出品者情報 */}
        <Grid container justifyContent="flex-start" alignItems="center" spacing={2}>
          <Grid item>
            <Typography variant="h6">出品者情報</Typography>
          </Grid>
          <Grid item>
            <Switch 
              checked={registeredSeller} 
              color="primary"
              onClick={(e) => e.preventDefault()}
              style={{ pointerEvents: 'none' }}
            />
          </Grid>
        </Grid>
        {registeredSeller && (
          <Card style={{ marginBottom: "16px" }}>
            <CardContent>
              <Typography variant="body1">名前: {sellerForm.name}</Typography>
              <Typography variant="body1">住所: {sellerForm.address}</Typography>
              <Typography variant="body1">電話番号: {sellerForm.phone}</Typography>
              <Typography variant="body1">
                郵便番号: {sellerForm.postalFirst}-{sellerForm.postalSecond}
              </Typography>
              <Typography variant="body1">
                適格請求書の登録番号: {sellerForm.invoiceRegistrationNumber || "未登録"}
              </Typography>
            </CardContent>
          </Card>
        )}
        <Grid container spacing={2} justifyContent="flex-start" style={{ marginBottom: "16px" }}>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/profile/seller/edit"
            style={{ width: '30%' }}
          >
            出品者情報を編集する
          </Button>
        </Grid>

        {/* ログイン情報 */}
        <Grid container justifyContent="flex-start" alignItems="center" spacing={2}>
          <Grid item>
            <Typography variant="h6">ログイン情報</Typography>
          </Grid>
          <Grid item>
            <Switch 
              checked={!!currentUserInfo.email} 
              color="primary"
              onClick={(e) => e.preventDefault()}
              style={{ pointerEvents: 'none' }}
            />
          </Grid>
          </Grid>

          {registeredSeller && (
          <Card style={{ marginBottom: "16px" }}>
            <CardContent>
              <Typography variant="body1">メールアドレス: {currentUserInfo.email}</Typography>
              <Typography variant="body1">パスワード: ******</Typography>
            </CardContent>
          </Card>
        )}
          <Grid container justifyContent="flex-start" style={{ marginBottom: "16px" }}>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/profile/login/edit"
            style={{ width: '32%' }}
          >
            ログイン情報を編集する
          </Button>
        </Grid>


        {/* Stripe連携 */}
        <Grid container justifyContent="flex-start" alignItems="center" spacing={2}>
          <Grid item>
            <Typography variant="h6">Stripe連携</Typography>
          </Grid>
          <Grid item>
            <Switch 
              checked={connectedStripe} 
              color="primary"
              onClick={(e) => e.preventDefault()}
              style={{ pointerEvents: 'none' }} 
            />
          </Grid>
        </Grid>
      </Box>
  );
};

export default Profile;